import { getVideoSchema } from 'client/seo/schemas/video';

export function getVideoSchemaData(videoEntry) {
  const thumbnailURL = videoEntry.metadata('thumbnailURL').value();
  const videoTranscript = videoEntry.metadata('videoTranscript').value();
  const videoDescription = videoEntry.metadata('videoDescription').value();
  const videoTitle = videoEntry.metadata('videoTitle').value();
  const uploadDate = videoEntry.metadata('uploadDate').value();
  const videoId = videoEntry.metadata('videoId').value();
  const youtubeVideoId = videoEntry.metadata('youtube-videoid').value();

  return getVideoSchema({
    thumbnailURL,
    videoTranscript,
    videoDescription,
    videoTitle,
    uploadDate,
    videoId,
    youtubeVideoId,
  });
}
